import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import {
  CmsConfig,
  FeaturesConfigModule,
  I18nModule,
  provideConfig,
  UrlModule
} from '@spartacus/core';
//import { OrderOverviewModule } from '@spartacus/order/components';
import {
  FormErrorsModule,
  PromotionsModule,
  PwaModule,
  SpinnerModule
} from '@spartacus/storefront';
import { CustomNewsletterModule } from '../../../../custom/cms-components/content/custom-newsletter/custom-newsletter.module';
import { CustomIconsModule } from '../../../../custom/icons/custom-icons.module';
import { CustomPipesModule } from "../../../../custom/pipes/custom-pipes";
import { effectsCheckout } from '../../core/src/checkout/store/effects';
import { defaultSpinnersLayoutConfig } from "../../default-spinners-layout.config";
import { CustomCartSharedModule } from '../cart/custom-cart-shared/custom-cart-shared.module';
import {
  CustomGuestRegisterFormComponent,
  CustomOrderConfirmationItemsComponent,
  CustomOrderConfirmationOverviewComponent,
  CustomOrderConfirmationThankYouMessageComponent,
  CustomOrderConfirmationTotalsComponent
} from './components';
import { CustomOrderConfirmationGuard } from './guards/custom-order-confirmation.guard';

@NgModule({
  imports: [
    CommonModule,
    CustomCartSharedModule,
    PwaModule,
    PromotionsModule,
    I18nModule,
    ReactiveFormsModule,
    FeaturesConfigModule,
    FormErrorsModule,
    /*    OrderOverviewModule, */
    EffectsModule.forFeature(effectsCheckout),
    RouterModule,
    UrlModule,
    CustomIconsModule,
    CustomNewsletterModule,
    SpinnerModule,
    CustomPipesModule,
  ],
  providers: [
    provideConfig(defaultSpinnersLayoutConfig),
    provideConfig({
      cmsComponents: {
        OrderConfirmationThankMessageComponent: {
          component: CustomOrderConfirmationThankYouMessageComponent,
          guards: [CustomOrderConfirmationGuard],
        },
        OrderConfirmationItemsComponent: {
          component: CustomOrderConfirmationItemsComponent,
          guards: [CustomOrderConfirmationGuard],
        },
        OrderConfirmationTotalsComponent: {
          component: CustomOrderConfirmationTotalsComponent,
          guards: [CustomOrderConfirmationGuard],
        },
        OrderConfirmationOverviewComponent: {
          component: CustomOrderConfirmationOverviewComponent,
          guards: [CustomOrderConfirmationGuard],
        },
      },
    } as CmsConfig),
  ],
  declarations: [
    CustomOrderConfirmationItemsComponent,
    CustomOrderConfirmationOverviewComponent,
    CustomOrderConfirmationThankYouMessageComponent,
    CustomOrderConfirmationTotalsComponent,
    CustomGuestRegisterFormComponent,
  ],
  exports: [
    CustomOrderConfirmationItemsComponent,
    CustomOrderConfirmationOverviewComponent,
    CustomOrderConfirmationThankYouMessageComponent,
    CustomOrderConfirmationTotalsComponent,
    CustomGuestRegisterFormComponent,
  ]
})
export class CustomOrderConfirmationModule {
}
